import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})

export class LoaderComponent implements OnInit {

  isLoading$: Observable<boolean>;

  constructor(private readonly loaderService: LayoutService) {
    this.isLoading$ = this.loaderService.loading$;
  }

  ngOnInit(): void {}
}
